import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'reactstrap';
import _ from 'lodash';
import { BrowserView, MobileView } from 'react-device-detect';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import CarSvg from './CarSvg';
import CarPhotoSlider from './CarPhotoSlider';
import CarDamageButton from './CarDamageButton';
import Translate from '../common/Translate';
import useValue from '../../services/Form/useValue';

const CarProfileContainer = ({ elementIds, showNav, setDisableNav, goNextQuestion, question, setValue: setOption }) => {
  const { questionId, sectionId, formId } = elementIds;
  const { width, height, id, type } = question;
  const [selectedZone, setSelectedZone] = useState('');
  const [zones, , refreshZones] = useValue(formId, sectionId, questionId, type, 'children');
  const [value, setValue] = useValue(formId, sectionId, questionId, type, 'value');
  const [value2] = useValue(formId, sectionId, questionId, type, `children.${selectedZone}.value`);

  // disable nevbar if value is false

  useEffect(() => {
    if (setDisableNav !== undefined) {
      if (value === false) setDisableNav(false);
      else setDisableNav(true);
    }
  });

  let images = 0;
  if (selectedZone !== '') {
    images = zones[selectedZone].images;
    if (images === undefined) images = 0;
    else images = Object.keys(images).length;
  }

  const resetState = (message) => {
    if (showNav) showNav(true);
    if (message === 'option') setSelectedZone('');
    refreshZones();
  };

  const handleSelectZone = (selection) => {
    let _selection = selection;
    if (_selection === selectedZone) {
      _selection = '';
      if (showNav) showNav(true);
    } else if (showNav) showNav(false);
    setSelectedZone(_selection);
    refreshZones();
  };
  // if click no damage btn initalise value true
  const handleClickNoOtherDamage = () => {
    setValue(true);
    if (typeof goNextQuestion === 'function') goNextQuestion();
  };

  const renderZoneTile = () => (
    <>
      <BrowserView>
        <div className="text-black-50">
          <Translate code={selectedZone} />
        </div>
      </BrowserView>

      <MobileView>
        <Container fluid>
          <div className="text-black-50">
            <Translate code={selectedZone} />
          </div>
        </Container>
      </MobileView>
    </>
  );

  const carSvgComponent = (
    <>
      <CarSvg
        width={width}
        height={height}
        profile={id}
        carType="berline"
        zones={_.flatMap(zones)}
        selectedZone={selectedZone}
        handleSelectZone={handleSelectZone}
      />
    </>
  );

  const noOtherDamageButton = (
    <Row className="mt-5">
      <Col className="text-center">
        <button
          type="button"
          className={`btn btn-outline-primary btn-chevron ${value ? 'btn-no-other-damage-selected' : ''}`}
          data-test={`${questionId}-noOtherDamage-button`}
          onClick={handleClickNoOtherDamage}
          data-cy={id}
        >
          <Translate code="no_other_zone_damage" />
        </button>
      </Col>
    </Row>
  );

  const handleOnClick = () => {
    resetState('option');
  };

  return (
    <div className="question-car-profile">
      {selectedZone && renderZoneTile()}
      <BrowserView>{carSvgComponent}</BrowserView>
      <MobileView>{(images === 0 || !selectedZone) && carSvgComponent}</MobileView>
      {selectedZone && (
        <CarPhotoSlider
          formId={formId}
          sectionId={sectionId}
          selectedZone={selectedZone}
          questionId={id}
          zone={zones[selectedZone]}
          resetState={resetState}
        />
      )}
      {selectedZone && (
        <CarDamageButton
          zone={zones[selectedZone]}
          setValue={setOption}
          formId={formId}
          sectionId={sectionId}
          questionId={questionId}
          questionType={type}
          resetState={resetState}
        />
      )}
      {!selectedZone && noOtherDamageButton}

      {images > 0 && value2 && (
        <Row className="mt-5">
          <Col className="text-left">
            <button type="button" className="btn btn-outline-primary" onClick={handleOnClick} data-cy="goBackBtn">
              <FontAwesomeIcon size="lg" icon={faArrowLeft} />
            </button>
          </Col>
        </Row>
      )}
    </div>
  );
};

export default CarProfileContainer;

CarProfileContainer.propTypes = {
  elementIds: PropTypes.shape().isRequired,
  question: PropTypes.shape().isRequired,
  showNav: PropTypes.func,
  setDisableNav: PropTypes.bool,
  goNextQuestion: PropTypes.func,
  formId: PropTypes.string.isRequired,
  sectionId: PropTypes.string.isRequired,
  setValue: PropTypes.func,
};

CarProfileContainer.defaultProps = {
  showNav: () => {},
  setDisableNav: undefined,
  goNextQuestion: undefined,
  setValue: undefined,
};
